module.exports = __webpack_public_path__ + "img/home.e5101844.png";